import { useFetchQuotesSummary } from '@features/invoices/hooks/useFetchQuotesSummary'

import { useQuotesListFilters } from '../context/quotesListFilters'

export const useQuotesSummaryFiltered = () => {
  const [{ customerId, period, searchQuery }] = useQuotesListFilters()

  return useFetchQuotesSummary({ customerId, period, searchQuery })
}
